import { createTheme } from "@mui/material";

export default createTheme({
  palette: {
    type: 'dark',
    mode: 'dark',
    primary: {
      main: '#F0F3F5', //Cool Gray 100
    },
    secondary: {
      main: '#EC0016', //Red 500
    },
    tertiary: {
      main: '#AFB4BB', //Cool Gray 300
    },
    info: {
      main: '#FFFFFF'
    },
    white: {
      main: '#FFFFFF'
    },
    grey: {
      main: '#646973' //Cool Gray 500
    },
    whitetrans: {
      main: '#676f80'
    },
    black: {
      main: '#000000'
    },
    success: {
      main: '#408335'
    }
  },
  typography: {
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
    fontWeightBold: 700,
    h1: {
      fontFamily: "DB Head Black",
      fontSize: 16,
      fontWeight: 700,
    },
    h2: {
      fontFamily: "DB Head Black",
      fontSize: 16,
      fontWeight: 400,
    },
    regular: {
      fontFamily: "DB Sans Regular",
    },
    button: {
      fontFamily: "DB Sans Regular",
      fontSize: 14,
    },
    body1: { //normaler Text
      fontFamily: "DB Sans Regular",
      fontSize: 16,
      fontWeight: 400
    },
    body2: { //normaler Text Bold
      fontFamily: "DB Sans Regular",
      fontSize: 16,
      fontWeight: 700
    }
  }
});